import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {setCurrentLayoutType} from "../models/navigationMenu/slice";
import {MOCK_PAGES} from "../mock";

export const useSyncLayoutWithRoute = () => {
    const location = useLocation();
    const dispatch = useDispatch();
    const projectInfo = useSelector(state => state.projectInfo.items);

    useEffect(() => {
        if (!projectInfo?.pageLayouts) return;

        const pageName = location.pathname
            .split("/")
            .filter(Boolean)
            .pop();

        const mockPage = MOCK_PAGES[pageName];
        if (mockPage) {
            dispatch(setCurrentLayoutType(mockPage.layoutType ?? 5));
            return;
        }

        const matchedLayout = projectInfo.pageLayouts.find(
            layout => layout.pageName === pageName
        );

        dispatch(
            setCurrentLayoutType(matchedLayout ? matchedLayout.layoutType : 5)
        );
    }, [location.pathname, projectInfo, dispatch]);
};
